import api from './api';

const administradorDbService = {
  /**
   * Busca todos os bancos
   */
  getAllBancos: async (): Promise<any[]> => {
    try {
      const response = await api.get('/bancos');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar bancos:', error);
      throw error;
    }
  },

  updateBanco: async (id: number, banco: any) => {
    const response = await api.post(`/bancos/${id}`, banco);
    return response.data;
  },
  /**
   * Cria um novo banco
   */
  createBanco: async (bancoData: any): Promise<any> => {
    try {
      const response = await api.post('/bancos', bancoData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar banco:', error);
      throw error;
    }
  },

  /**
   * Executa as migrações
   */
  runMigrations: async (banco:any): Promise<any> => {
    try {
      const response = await api.post('/migrate',banco);
      return response.data;
    } catch (error) {
      console.error('Erro ao executar migrações:', error);
      throw error;
    }
  },

  /**
   * Busca os logs de migração
   */
  getMigrationLogs: async (banco: string): Promise<any[]> => {
    try {
      const response = await api.get('/migration-logs', {
        params: {
          banco: banco, // Passando o banco como parâmetro na URL
        },
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar logs de migração:', error);
      throw error;
    }
  }
};

export default administradorDbService;
